var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn__primary btn__lg",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.emitClick($event)}}},[_vm._v(_vm._s(_vm.btnText))])])}
var staticRenderFns = []

export { render, staticRenderFns }